<template>
    <BCol cols="12" :md="vsMd">
        <ValidationProvider #default="validationContext" :name="$t(vsName)" :rules="vsRules">
            <BFormGroup :label="$t(vsName)" :label-for="encodeURIComponent(vsName).replace('%20','_').toLowerCase()" :class="vsRequired == '' ? 'required-field' : ''">
                <BFormDatepicker start-weekday="1"  :reset-button="vsReset" :disabled="vsDisabled" @input="inputFunctions($event)" :value="vsModel" locale="es" :min="data" :max="vsMax"></BFormDatepicker>
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { BCol, BFormGroup, BFormDatepicker, BFormInvalidFeedback } from 'bootstrap-vue';
import { toRefs, watch, ref, onMounted } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormDatepicker, BFormInvalidFeedback },
    props: ['vsName','vsDisabled' , 'vsModel', 'vsMd', 'vsRules', 'vsRequired', 'vsMin', 'vsMax', 'vsReset'],
    emit: ['update:vsModel', 'vsOnInput'],
    setup(props,  ctx) {
        const { getValidationState } = formValidation()
        const { vsMin, vsModel } = toRefs(props)
        const data=ref(null)

        watch(vsMin, () =>{
            minDate()
        })


        const minDate = () => {
            data.value= new Date(vsMin.value)
            data.value.setDate(data.value.getDate() + 1)
            data.value=data.value.toISOString().split("T")[0];
            
            if(new Date(data.value) > new Date(vsModel.value)){
                ctx.emit('update:vsModel', null)
            }
        }

        const inputFunctions = function(event){
            ctx.emit('update:vsModel', event)
            ctx.emit('vsOnInput', event)
        }

        if (vsMin.value) {
            minDate()
        }


        



        return {
            getValidationState,
            data,
            inputFunctions
        }
    },
}
</script>

<style>

</style>